// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ly-2";
export var container = "_ly-4";
export var dismissButton = "_ly-3";
export var hasPaddingBottom = "_ly-6";
export var last = "_ly-e";
export var scrollbarThumb = "_ly-c";
export var scrollbarTrack = "_ly-b";
export var selected = "_ly-9";
export var spin = "_ly-1";
export var spinning = "_ly-0";
export var suggestionItem = "_ly-d";
export var suggestionsPanel = "_ly-5";
export var tonePill = "_ly-8";
export var tonesContainer = "_ly-7";
export var unselected = "_ly-a";